'use strict';

angular.module('amexReconciliationApp')
  .component('transactionLockIcon', {
    templateUrl: 'scripts/views/components/transaction-lock-icon.html',
    bindings: { transaction: '<' },
    controller: function (SiteConfigModel, ReceiptService) {

      var self = this;

      self.partialLockSettings = {};
      
      self.isPartiallyLocked = function() {
        return self.transaction.lockStatus === 'PARTIALLY_LOCKED';
      };

      self.isFullyLocked = function() {
        return self.transaction.lockStatus === 'FULLY_LOCKED';
      };

      self.isHeld = function() {
        return SiteConfigModel.isOibEnabled() && _.get(self.transaction, 'transactionHold.hold', false) && !isLocked();
      };

      self.getPartialLockSettings = function() {

        var partialLockOptions = SiteConfigModel.siteConfig().partialLockOptions;
        var settings = [];
        settings.push({
          label: 'accounting',
          value: partialLockOptions.accountingLocked ? 'locked' : 'editable'
        });

        if (SiteConfigModel.approvalSettingOnForRole()) {
          settings.push({
            label: 'approvals',
            value: partialLockOptions.approvalsLocked ? 'locked' : 'enabled'
          });
        }

        settings.push({
          label: 'comments',
          value: partialLockOptions.commentsLocked ? 'locked' : 'editable'
        });

        if (SiteConfigModel.cycleReceiptsEnabled() || SiteConfigModel.transactionReceiptsEnabled()) {
          settings.push({
            label: 'receipts',
            value: ReceiptService.receiptUploadingIsLocked() ? 'locked' : 'enabled'
          });
        }

        if (SiteConfigModel.siteConfig().userDefinedFields.length > 0) {
          settings.push({
            label: 'additionalTransactionFields',
            value: partialLockOptions.userDefinedFieldsLocked ? 'locked' : 'editable'
          });
        }

        if (SiteConfigModel.showReceivedFields()) {
          settings.push({
            label: 'receivedFields',
            value: partialLockOptions.receiverLocked ? 'locked' : 'editable'
          });
        }

        settings.push({
          label: 'estimatedTax',
          value: partialLockOptions.estimatedTaxLocked ? 'locked' : 'editable'
        });

        self.partialLockSettings = settings;

      };

      function isLocked() {
        return self.isPartiallyLocked() || self.isFullyLocked();
      }

    }

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionLockIcon.js
// module id = 494
// module chunks = 0